import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';

const WrapperAlerts = ({ children }) => {
  const nodeRef = useRef(null);

  return (
    <div id="wrapper-alerts">
      <div
        className="wrapper-alerts"
        ref={nodeRef}
      >
        {children}
      </div>
    </div>
  );
};

WrapperAlerts.propTypes = {
  children: PropTypes.node,
};

export default memo(WrapperAlerts);
